import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LogIn, Mail, KeyRound, Store } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { api, errMsg } from "@/lib/api";
import { installShop } from "@/lib/telemetry";
import AuthLayout from "@/pages/AuthLayout";
import { BigButton, Field, inputCls } from "@/components/ui-kit";

export default function Login() {
  const { login, t, online } = useApp();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [shop, setShop] = useState(null);
  useEffect(() => {
    const id = new URLSearchParams(window.location.search).get("shop") || installShop();
    if (!id) return;
    api.get(`/public/shop/${id}/login-info`).then((r) => { setShop(r.data); if (r.data.owner_email) setEmail(r.data.owner_email); }).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try { await login(email, password); } catch (ex) { const m = errMsg(ex); setErr(online ? (["store_suspended", "account_disabled"].includes(m) ? t(m) : m) : t("need_internet")); }
    setBusy(false);
  };

  return (
    <AuthLayout title={t("login_title")} subtitle={t("login_sub")}>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        {shop && (
          <div className="flex items-center gap-3 rounded-xl bg-[#F4F7FB] border border-[#1F4E8C]/20 p-3" data-testid="login-shop-banner">
            {shop.has_logo ? <img src={`${process.env.REACT_APP_BACKEND_URL}/api/public/shop/${shop.id}/logo`} alt="" className="w-10 h-10 rounded-lg object-cover bg-white" /> : <span className="w-10 h-10 rounded-lg bg-[#1F4E8C] text-white grid place-items-center"><Store className="w-5 h-5" /></span>}
            <span className="min-w-0"><span className="block text-xs text-muted-foreground">{t("login_for_shop")}</span><span className="block font-bold truncate" data-testid="login-shop-name">{shop.name}</span></span>
          </div>
        )}
        <Field label={<span className="flex items-center gap-1.5"><Mail className="w-4 h-4" />{t("email")}</span>}>
          <input type="email" required dir="ltr" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="login-email-input" />
        </Field>
        <Field label={<span className="flex items-center gap-1.5"><KeyRound className="w-4 h-4" />{t("password")}</span>}>
          <input type="password" required dir="ltr" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="login-password-input" />
        </Field>
        {err && <p className="text-destructive font-bold" data-testid="login-error">{err}</p>}
        <BigButton type="submit" variant="gold" disabled={busy} className="w-full" data-testid="login-submit-button"><LogIn className="w-5 h-5" />{t("login")}</BigButton>
      </form>
      <p className="mt-6 text-center">
        {t("no_account")} <Link to="/register" className="text-primary font-bold" data-testid="go-register-link">{t("create_shop")}</Link>
      </p>
    </AuthLayout>
  );
}
